module.exports = __webpack_public_path__ + "img/mobileApp.ed03c376.jpg";